module.exports = __webpack_public_path__ + "img/personalEnM.1befabef.jpg";